import axios from "../../privateApi";

export type AppPlatform = "ios" | "android";

export type AppWaitlistSignup = {
  feature: `app-${AppPlatform}`;
  createdAt: string;
};

/** One waitlist per platform, so the same email can join both. */
const path = (platform: AppPlatform) =>
  `users/waitlist-sign-up/app-${platform}`;

/** No login needed. Idempotent: signing up twice keeps the first signup. */
export const joinAppWaitlist = (platform: AppPlatform, email: string) =>
  axios
    .post<AppWaitlistSignup>(path(platform), { email })
    .then((res) => res.data);
